module.exports = __webpack_public_path__ + "img/allottee4_7-8-2021.598b6570.jpg";